// src/components/RootRedirect.jsx
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Navigate } from 'react-router-dom';
import findFirstAllowedPath from '../utils/findFirstAllowedPath';

const PERM_TO_PATH = [
  ['dashboard:access',          '/dashboard'],
  ['recipes:access',            '/recipes/recipesbyevent'],
  ['ingredients:access',        '/ingredients'],
  ['content:access',            '/content'],
  ['users:access',              '/users'],
  ['hardware:access',           '/hardware'],
  ['googleanalytics:access',    '/googleanalytics/home'],
  ['firebaseanalytics:access',  '/firebaseanalytics/home'],
  ['orders:access',             '/orders'],
  ['ai:access',                 '/ai'],
  ['dashboardadmindata:access', '/dashboardadmindata'],
];

const EMPTY = Object.freeze([]);

export default function RootRedirect() {
  const isAuthenticated = useSelector(s => s.auth.isAuthenticated);
  const permsRedux      = useSelector(s => s.auth.permissions, shallowEqual) || EMPTY;
  const adminRedux      = useSelector(s => s.auth.logininfo?.adminFlag ?? 0);

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // fallbacks from localStorage for first render after login/refresh
  let perms = permsRedux;
  if (!perms.length) {
    try { perms = JSON.parse(localStorage.getItem('permissions') || '[]'); } catch {}
  }
  const isAdmin = Number(adminRedux || localStorage.getItem('adminFlag') || 0) === 1;

  // If not admin and no perms yet, wait (prevents redirect loops/blank)
  if (!isAdmin && (!perms || perms.length === 0)) {
    return null; // or a small spinner if you want
  }

  // Try menu-driven first allowed path
  let target = findFirstAllowedPath(perms, isAdmin);

  // Last-ditch: derive from the first permission you do have
  if (!target) {
    const hit = PERM_TO_PATH.find(([code]) => perms.includes(code));
    target = hit ? hit[1] : '/login';
  }

  return <Navigate to={target} replace />;
}
